import { type PaymentProfiles, type Situation } from '../types'

type Config = {
  stoneCode: any
  accountScopes?: string[]
  situation?: Situation
  paymentProfiles?: PaymentProfiles[]
}

export function entityRoles(config: Config) {
  const { stoneCode, accountScopes, situation, paymentProfiles } = config

  const acquirer =
    situation === 'one_stone' ? Boolean(paymentProfiles && paymentProfiles.length > 0) : Boolean(stoneCode)

  return {
    acquirer,
    banking: Boolean(accountScopes?.includes('paymentaccount:read')),
    credit: Boolean(accountScopes?.includes('paymentaccount:read') && accountScopes?.includes('paymentaccount:loans'))
  }
}
